module.exports = __webpack_public_path__ + "static/media/plan-C2a-mobile-tc.9c1071f0.png";